import { app } from "../firebase";
import { getDatabase, ref, get, set, push, child, remove, update } from "firebase/database";

function getClientsCollectionByCompany(companyId) {
  return `companies/${companyId}/clients`;
}

export async function getClientNameById(companyId, clientId) {
  if (!clientId) return "";
  try {
    const db = getDatabase(app);
    const userRef = ref(db, `companies/${companyId}/clients/${clientId}`);
    const snap = await get(userRef);

    if (snap.exists()) {
      return snap.val().name; 
    } else {
      return null;
    }
  } catch (error) {
    console.error("Erro ao buscar nome do cliente por ID:", error);
    return "";
  }
}

export async function getClientById(companyId, clientId) {
  if (!clientId) return "";
  try {
    const db = getDatabase(app);
    const userRef = ref(db, `companies/${companyId}/clients/${clientId}`);
    const snap = await get(userRef);

    if (snap.exists()) {
      return snap.val(); 
    } else {
      return null;
    }
  } catch (error) {
    console.error("Erro ao buscar nome do cliente por ID:", error);
    return "";
  }
}

function sanitizeKeys(obj) {
  if (obj && typeof obj === "object" && !Array.isArray(obj)) {
    const sanitized = {};
    for (const key in obj) {
      if (!key) continue; 
      const safeKey = key.replace(/[.#$/[\]]/g, "_"); 
      sanitized[safeKey] = sanitizeKeys(obj[key]);
    }
    return sanitized;
  }
  return obj;
}

function removeUndefined(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export const saveClient = async (companyId, data) => {
  const db = getDatabase(app);
  if (!companyId) throw new Error("Nenhum ID de empresa fornecido.");

  const cleanData = sanitizeKeys(removeUndefined(data));
  const newClientRef = push(ref(db, getClientsCollectionByCompany(companyId)));
  const newClientId = newClientRef.key;

  await set(newClientRef, cleanData);
  return { id: newClientId, ...cleanData };
};

export const deleteClient = async (companyId, clientId) => {
  if (!companyId || !clientId) throw new Error("IDs inválidos para exclusão");
  const db = getDatabase(app);
  await remove(ref(db, `${getClientsCollectionByCompany(companyId)}/${clientId}`));
};

export const updateClient = async (companyId, clientId, data) => {
  if (!companyId || !clientId) throw new Error("IDs inválidos");
  const db = getDatabase(app);
  const cleanData = sanitizeKeys(removeUndefined(data));
  await update(ref(db, `${getClientsCollectionByCompany(companyId)}/${clientId}`), cleanData);
  return { id: clientId, ...cleanData };
};

export const getClients = async (companyId) => {
  const db = getDatabase(app);
  if (!companyId) throw new Error("Nenhum ID de empresa fornecido.");

  const dbRef = ref(db);
  const snapshot = await get(child(dbRef, getClientsCollectionByCompany(companyId)));

  if (snapshot.exists()) {
    const data = snapshot.val();
    return Object.entries(data).map(([id, value]) => ({
      id,
      ...value,
    }));
  }
  return [];
};
